import type { ActionFunction } from '~/types/route-args';
import type {
    AddToShoppingCartMutationVariables,
    ShippingProviderEnum,
} from 'generated/graphql';
import { addToShoppingCart } from '@modules/ecommerce/api/add-to-shopping-cart.server';

export const ADD_TO_SHOPPING_CART_API_ROUTE =
    '/remix-api/ecommerce/add-to-shopping-cart';

export const action: ActionFunction = async ({ request, context }) => {
    const data = await request.formData();

    const variables: AddToShoppingCartMutationVariables = {
        variant: Number(data.get('variant')),
    };

    if (data.get('pickupLocation')) {
        variables.pickupLocation = Number(data.get('pickupLocation'));
    }

    if (data.get('quantity')) {
        variables.quantity = Number(data.get('quantity'));
    }

    if (data.get('shippingMethod')) {
        variables.shippingMethod = Number(data.get('shippingMethod'));
    }

    if (data.get('shippingProvider')) {
        variables.shippingProvider = String(
            data.get('shippingProvider'),
        ) as ShippingProviderEnum;
    }

    if (data.get('sample')) {
        variables.sample = data.get('sample') === 'true';
    }

    return addToShoppingCart({
        ...context,
        variables,
    });
};
